<template>
  <a-card :bordered="false" class="m-b-20">
    <SmallSquare class="m-b-10" :content='$route.query.dealer_name' v-if='$route.query.dealer_name' />
    <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="请选择">
        <a-select v-model:value="search.search_date_type" style="width: 120px" @focus="focus" ref="select" @change="handleChange">
          <a-select-option value="1">日</a-select-option>
          <a-select-option value="2">自然周</a-select-option>
          <a-select-option value="3">自然月</a-select-option>
          <a-select-option value="4">近7天</a-select-option>
          <a-select-option value="5">自定义时间</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="">
        <a-date-picker v-model:value="search.search_time" v-if="search.search_date_type=='1'" valueFormat='YYYY-MM-DD' :disabledDate="disabledDate" format='YYYY-MM-DD' @change="isData"/>
        <a-week-picker v-else-if="search.search_date_type=='2'" @change="changeWeek" v-model:value="weekTime" :disabledDate="disabledDate" />
        <a-month-picker v-model:value="search.search_time" v-else-if="search.search_date_type=='3'" valueFormat='YYYY-MM' format='YYYY-MM'  :disabledDate="disabledDate" @change="isData"/>
        <a-range-picker v-if="search.search_date_type=='5'" v-model:value="rangeTime" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' :disabledDate="disabledDate" @change="changeRange" />
      </a-form-item>
          <a-form-item label="所属上级" name='dealer_id' >
          <a-input v-model:value="search.dealer_name" readonly allClerk placeholder='请选择上级' />
          <CloseCircleFilled class="fz-14 s_c999" style="position: absolute;right: 5px;top: 8px;" v-if='search.dealer_name'  @click='search.dealer_name="";search.dealer_sn="";' />
        </a-form-item>
           <a-form-item label="" name=''>
          <a-button type="primary" @click='showDealer = true'>选择</a-button>
        </a-form-item>
      <a-form-item>
        <a-button type="primary" @click="onSearch">搜索</a-button>
      </a-form-item>
      <a-form-item>
        <a-button v-has:antiStatisticsStoreGoodExport="exportTable">导出</a-button>
      </a-form-item>
    </a-form>
  </a-card>
  <a-card :bordered="false" class="m-b-20">
    <div class="s_flex_ali dataPanel s_bf58 p-15 m-b-60">
      <div class="flex_1">
        <div class=" bor-rad-10 p-l-20 s_po_re  p-t-20 p-b-20 s_bf m-r-20 m-l-20">
          <p class=" s_font_b s_c333 m-b-10">签收商品数量 <a-tooltip placement='right'>
              <template #title>统计时间内全部门店签收的商品数量
              </template>
              <QuestionCircleOutlined class="s_c376" />
            </a-tooltip>
          </p>
          <p class="s_cE84848 s_font_b fz-26">{{detail.warehouse_num}}</p>
        </div>
      </div>
      <div class="flex_1">
        <div class=" bor-rad-10 p-l-20 s_po_re  p-t-20 p-b-20 s_bf m-r-20 m-l-20">
          <p class="s_c333 s_font_b m-b-10">退货商品数量 <a-tooltip placement='right'>
              <template #title>统计时间内全部门店成功退货的商品数量
              </template>
              <QuestionCircleOutlined class="s_c376" />
            </a-tooltip>
          </p>
          <p class="s_cE84848 s_font_b fz-26">{{detail.refund_warehouse_num}}</p>
        </div>
      </div>
      <div class="flex_1">
        <div class=" bor-rad-10 p-l-20 s_po_re  p-t-20 p-b-20 s_bf m-r-20 m-l-20">
          <p class="s_c333 s_font_b m-b-10">出售商品数量 <a-tooltip placement='right'>
              <template #title>统计时间内全部门店的扫码出售商品数量
              </template>
              <QuestionCircleOutlined class="s_c376" />
            </a-tooltip>
          </p>
          <p class="s_cE84848 s_font_b fz-26">{{detail.out_warehouse_num}}</p>
        </div>
      </div>
    </div>
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='store_sn' :columns='columns' :data-source='list'>
      <template v-slot:warehouse_num="{ record }">
        <a @click="showCodeLog=Number(record.warehouse_num) > 0?true:false;numType=1;itemId=record.id" href="javascript:;">{{record.warehouse_num}}</a>
      </template>
      <template v-slot:out_warehouse_num="{ record }">
        <a @click="showCodeLog=Number(record.out_warehouse_num) > 0?true:false;numType=2;itemId=record.id" href="javascript:;">{{record.out_warehouse_num}}</a>
      </template>
      <template v-slot:refund_warehouse_num="{ record }">
        <a @click="showCodeLog=Number(record.refund_warehouse_num) > 0?true:false;numType=3;itemId=record.id" href="javascript:;">{{record.refund_warehouse_num}}</a>
      </template>
    </a-table>
    <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>
  <a-modal title='二维码详情' :keyboard="false" :maskClosable='false' v-model:visible="showCodeLog" destroyOnClose :footer='null' :width="1200" centered>
    <codeLog :id="itemId" :type='2' :numType='numType' :start='search.start_time' :end='search.end_time' />
  </a-modal>
  <a-modal  :keyboard="false" title="选择经销商" centered v-model:visible="showDealer" :width='1000' :footer="null" destroyOnClose>
    <selectDealer v-on:select="dealerSelect" :parent_dealer_id="0"></selectDealer>
  </a-modal>
</template>
<script>
import { QuestionCircleOutlined } from "@ant-design/icons-vue";
import { useTime } from "@/hooks/utils/useTime";
import { reactive, ref, toRefs } from "@vue/reactivity";
import { useECharts } from "@/hooks/useECharts.js";
import { inject, onMounted } from "@vue/runtime-core";
import { storeProduct } from "@/api/antiFleeing";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import config from '@/config'
import codeLog from '../components/codeLog'

export default {
  components: { QuestionCircleOutlined,codeLog },
  setup() {
    const momentTime = inject("momentTime");
    const search = ref({
      search_date_type: "1",
      start_time: "",
      end_time: "",
      limit: 10,
      pages: 1,
      dealer_name:"",
      dealer_sn:"",
      dealer_id:""
    });
    const state = reactive({
      showDealer:false,
      rangeTime:[],
      list: [],
      total: 0,
      detail: {},
      itemId:'',
      numType:'',
      listLoading:false,
      showCodeLog:false,
       is_day:true, //判断是否为空
      disabledDate :function(current) {
        return current && current > momentTime().subtract(1, 'days').endOf('day')
      },
    });
    const dateTime = reactive({
      dayTime: "",
      weekTime: "",
      monthTime: "",
      quarterTime: "",
      time: [],
    });
    const { dateTargets, typeToStartEnd,dataBefore } = useTime();
    const onSearch = () => {
       if(!state.is_day){
         message.error("请选择日期！");
        return;
      }
      if (search.value.search_date_type == 2 && !search.value.search_time) {
        message.error("请选择周");
        return;
      }
      changNav();
    };
    // 切换时间
    const handleChange = (e) => {
      search.value.search_time = "";
      switch (e) {
        case "1":
          search.value.search_time = typeToStartEnd("1").start_time;
          search.value.end_time = typeToStartEnd("1").end_time;
          search.value.start_time = typeToStartEnd("1").start_time;
           state.is_day = true;
          break;
        case "2":
          search.value.start_time = typeToStartEnd("7").start_time;
          search.value.end_time = typeToStartEnd("7").end_time;
          search.value.search_time =
            typeToStartEnd("7").start_time + "," + typeToStartEnd("7").end_time;
          dateTime.weekTime = typeToStartEnd("week").end_time;
           state.is_day = true;
          break;
        case "3":
          search.value.search_time = dateTargets("month");
          search.value.start_time = typeToStartEnd("month").start_time;
          search.value.end_time = typeToStartEnd("month").end_time;
           state.is_day = true;
          break;
        case "4":
          search.value.search_time = typeToStartEnd("1").start_time;
          search.value.end_time = typeToStartEnd("1").end_time;
          search.value.start_time = typeToStartEnd("7").start_time;
           state.is_day = true;
          break;
          case "5":
          state.rangeTime = [dataBefore(),dataBefore()]
          search.value.end_time = state.rangeTime[1];
          search.value.start_time = state.rangeTime[0];
           state.is_day = true;
          break;
      }
    };
    // 切换周
    const changeWeek = (weekData) => {
      if (!weekData) {
        search.value.search_time = "";
        return;
      }
      const startDate = momentTime(weekData).day(1).format("YYYY-MM-DD"); // 周一日期
      const endDate = momentTime(weekData).day(7).format("YYYY-MM-DD"); // 周日日期
      search.value.search_time = startDate + "," + endDate;
    };
    const datedifference = (date1,date2) =>{
      var sDate = new Date(date1)
      var eDate = new Date(date2)
      var aDay = 24*60*60*1000
      var diffDay = (eDate-sDate)/aDay
      return diffDay
    }
    //选择时间段
    const changeRange = (e) =>{
       state.is_day = !!e[0];
      if(datedifference(e[0],e[1]) > 90){
        state.rangeTime = []
        message.error('时间间隔不能大于90天')
      }else{
        search.value.start_time = e[0]
        search.value.end_time = e[1]
      }
    } 
    let columns = [
      {
        title: "门店名称",
        dataIndex: "store_name",
        key: "store_name",
      },
      {
        title: "门店编号",
        dataIndex: "store_sn",
        key: "store_sn",
      },
      {
        title: "门店等级",
        dataIndex: "store_level",
        key: "store_level",
      },
      {
        title: "签收商品数量",
        dataIndex: "warehouse_num",
        key: "warehouse_num",
        slots: { customRender: 'warehouse_num' }
      },
      {
        title: "出售商品数量",
        dataIndex: "out_warehouse_num",
        key: "out_warehouse_num",
        slots: { customRender: 'out_warehouse_num' }
      },
      {
        title: "退货商品数量",
        dataIndex: "refund_warehouse_num",
        key: "refund_warehouse_num",
        slots: { customRender: 'refund_warehouse_num' }
      },
    ];
    var $moment = inject("momentTime");
    var $route = inject("$route");
    const getLine = async () => {
      switch (search.value.search_date_type) {
        case "1":
          search.value.end_time = search.value.search_time;
          search.value.start_time = search.value.search_time;
          break;
        case "2":
          search.value.start_time = search.value.search_time.split(",")[0];
          search.value.end_time = search.value.search_time.split(",")[1];
          break;
        case "3":
          search.value.start_time = $moment(search.value.search_time)
            .startOf("month")
            .format("YYYY-MM-DD");
          search.value.end_time = $moment(search.value.search_time)
            .endOf("month")
            .format("YYYY-MM-DD");
          break;
      }
      state.listLoading=true
      let result = await storeProduct({
        ...search.value,
        dealer_sn: $route.query.dealer_sn,
      }).then((res) => res.data).catch((error) => error);
      state.listLoading=false;
      if(iscode(result)){
        // 整理数据
      var chartsList = [];
      state.detail = result.data;
      state.list = result.data.data;
      state.total = result.data.total;
      return chartsList;
      }else{
          state.list = [];
          state.total = 0;
          message.error(result.msg)
        }
    };
    const changNav = async () => {
      var lines = await getLine();
    };
    onMounted(() => {
      handleChange("1");
      changNav(1);
    });
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      changNav();
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      changNav();
    };
    //导出
    const exportTable=async ()=>{
      const hide = message.loading('正在加载中...', 0);
      let result = await storeProduct({...search.value,dealer_sn: $route.query.dealer_sn,excel:1}).then(res=>res.data).catch(error=>error);
      if(iscode(result,true)){
        window.open(config.onlineOrderUrl[process.env.VUE_APP_type]+'download?key='+result.data.key)
      }
      setTimeout(hide);
    }
      const isData = function(val){
      state.is_day = !!val
    }
            //选择经销商
    const dealerSelect = (e) => {
        if (e == 0) {
          search.value.dealer_name = '总部'
          search.value.dealer_sn =0
          search.value.dealer_id=0
        }else{
          search.value.dealer_name = e.dealer_name
          search.value.dealer_sn = e.dealer_sn
          search.value.dealer_id=e.dealer_id
        }
        state.showDealer = false
     getLine()
      }
    return {
      ...toRefs(dateTime),
      ...toRefs(state),
      search,
      handleChange,
      changNav,
      onSearch,
      changeWeek,
      pageCurrentChange,
      pageSizeChange,
      columns,
      exportTable,
      changeRange,
      isData,
      dealerSelect
    };
  },
};
</script>
<style lang="less" scoped>
.data-content-nav {
  background: #eee;
  border-radius: 10px;

  .data-content-nav-item {
    color: #8e8e8e;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
    cursor: pointer;
    text-align: center;
    .title {
      font-size: 16px;
      color: #000000;
    }

    .num {
      font-size: 34px;
      color: #000;
    }
    &.active {
      background-color: #fff;
      box-shadow: 0px 0px 10px 0px rgba(27, 66, 108, 0.28);
      border-radius: 10px;
    }
  }
}
.active {
  border: 1px solid #bbddff;
  box-shadow: 7px 5px 22px 0px #9cb9d7;
  position: relative;
  left: -5px;
  top: -5px;
}
</style>